import { Send } from '@material-ui/icons'
import { SyntheticEvent, useEffect, useRef, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import {
  createMessage,
  getActivityByProject,
  markMessagesAsRead,
} from '../../actions/activityActions'
import { ACTIVITY_MESSAGE_CREATE_RESET } from '../../constants/activityConstants'
import { useInput } from '../../hooks/useInput'
import TextAreaInput from '../Form/TextAreaInput'
import Loader from '../Loader/Loader'
import ActivityItem from './ActivityItem'

const ActivityPanel = () => {
  const dispatch = useDispatch()
  const bottomRef = useRef<HTMLDivElement | null>(null)

  const [textareaExpanded, setTextareaExpanded] = useState(false)

  const {
    bind: bindMessage,
    value: message,
    setValue: setMessage,
    setError: setMessageError,
    error: messageError,
  } = useInput('')

  const { userInfo } = useSelector((state: RootStateOrAny) => state.userLogin)
  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { success: sendMessageSuccess, loading: sendMessageLoading } =
    useSelector((state: RootStateOrAny) => state.activitySendMessage)
  const { activities } = useSelector(
    (state: RootStateOrAny) => state.activityByProject
  )

  const scrollBottom = () => {
    bottomRef.current?.scrollIntoView({
      behavior: 'auto',
      block: 'start',
    })
  }

  useEffect(() => {
    dispatch(markMessagesAsRead(project._id))
  }, [dispatch, project])

  useEffect(() => {
    if (sendMessageSuccess) {
      dispatch({ type: ACTIVITY_MESSAGE_CREATE_RESET })
      dispatch(getActivityByProject(project._id))
      setMessage('')
    }

    scrollBottom()
  }, [sendMessageSuccess, dispatch, project, activities, setMessage])

  const submitHandler = (e: SyntheticEvent) => {
    e.preventDefault()

    if (message === '') {
      setMessageError('Please enter a message')
    } else {
      const activity = {
        user: userInfo._id,
        project: project._id,
        projectName: project.name,
        message,
      }

      dispatch(createMessage(activity))
    }
  }

  const expandTextArea = () => {
    setTextareaExpanded(true)
  }

  const collapseTextArea = () => {
    setTextareaExpanded(false)
  }

  return (
    <div className="activities">
      <div className="header flex space-between align-center">
        <h5 className="fs16 m-b-0 p-t-8 p-b-5">Activity</h5>
      </div>
      <div
        id="activity-list"
        className={`scrollable ${textareaExpanded ? 'textarea-expanded' : ''}`}
      >
        {activities &&
          activities.length > 0 &&
          activities.map((item: Activity, index: number) => (
            <ActivityItem key={index} item={item} />
          ))}
        <div ref={bottomRef} className="list-bottom"></div>
      </div>
      <form
        onSubmit={submitHandler}
        className="form-container p-t-16 p-r-16 p-b-24 p-l-16"
      >
        <TextAreaInput
          type="text"
          name="message"
          className={!textareaExpanded ? 'short' : 'expanded'}
          bindValue={bindMessage}
          endAdornment={true}
          handleClick={submitHandler}
          icon={sendMessageLoading ? <Loader /> : <Send />}
          disabled={sendMessageLoading}
          error={messageError}
          autoComplete="off"
          onFocus={expandTextArea}
          onBlur={collapseTextArea}
        />
      </form>
    </div>
  )
}

export default ActivityPanel
